import { render, staticRenderFns } from "./calibrationLablist.vue?vue&type=template&id=0a6c8088&"
import script from "./calibrationLablist.vue?vue&type=script&lang=js&"
export * from "./calibrationLablist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports